import Vue from "vue";
import { createProvider } from "./vue-apollo";
import Buefy from "buefy";
import VeeValidate from "vee-validate";
import IdleVue from "idle-vue";
import VueHtmlToPaper from "vue-html-to-paper";
import VueMoment from "vue-moment";
import Print from 'vue-print-nb'
 

// User Imports
import App from "./App.vue";
import router from "./router/index";
import store from "./store/index";

// Styling
import "@mdi/font/css/materialdesignicons.min.css";
import "bulma-steps/dist/css/bulma-steps.min.css";
import "bulma-helpers/css/bulma-helpers.min.css";
import "vue-tel-input/dist/vue-tel-input.css";

// JS Imports

//Global Components Import
import PageTitle from "./modules/commonModule/components/PageTitle.vue";

import "vue-multiselect/dist/vue-multiselect.min.css";
import "nprogress/nprogress.css";

/**
 * Options for the idle-vue plugin which handles logging out the user after 5 minutes of inactivity
 */
const eventsHub = new Vue();
const idleVueOptions = {
  eventEmitter: eventsHub,
  idleTime: 60000 * 25,
  store,
  startAtIdle: false
};

const options = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
  styles: [
    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
    "https://unpkg.com/kidlat-css/css/kidlat.css"
  ]
};

Vue.use(VueMoment);
Vue.use(Buefy);
Vue.use(VeeValidate);
Vue.use(IdleVue, idleVueOptions);
Vue.use(VueHtmlToPaper, options);
Vue.use(Print);
Vue.config.productionTip = false;

Vue.component("PageTitle", PageTitle);

new Vue({
  router,
  store,
  apolloProvider: createProvider(),
  render: h => h(App)
}).$mount("#app");
